// sass
import "./src/styles/app.scss";
import "swiper/css/bundle";

// fontawesome
import { config, dom, library } from "@fortawesome/fontawesome-svg-core";
import { faEnvelope, faPlayCircle } from "@fortawesome/free-regular-svg-icons";
import {
    faAngleUp,
    faCheckCircle,
    faExclamationCircle,
    faGlassCheers,
    faGuitar,
    faHeadphones,
    faPencilAlt,
    faPlay,
    faShoppingCart,
    faUserCircle,
    faUserFriends
} from "@fortawesome/free-solid-svg-icons";
// 見つからない場合のiconを表示させない
config.showMissingIcons = false
// fontの追加
library.add(
    faPlayCircle,
    faEnvelope,
    faHeadphones,
    faAngleUp,
    faExclamationCircle,
    faCheckCircle,
    faUserCircle,
    faPencilAlt,
    faUserFriends,
    faGlassCheers,
    faPlay,
    faShoppingCart,
    faGuitar
)
// svgタグに変換
dom.watch()
